var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"position":"fixed","bottom":"0","width":"100vw","z-index":"1000","overflow":"hidden","background":"white","font-size":"16px","border-top":"1px solid #fafafa"}},_vm._l((_vm.bottomNav),function(nav,index){return _c('div',{key:index,class:nav.selected ? 'selected' : '',style:({
        'font-size': '18px',
        width: '49vw',
        'text-align': 'center',
        float: 'left',
        'line-height': '50px',
        'border-right':
          index !== _vm.bottomNav.length - 1 ? '1px solid #f0f0f0' : ''
      }),on:{"click":function($event){return _vm.onNavClicked(nav)}}},[_c('i',{class:nav.icon}),_vm._v("\n      "+_vm._s(nav.name)+"\n    ")])}),0),_vm._v(" "),_c('div',{staticStyle:{"height":"50px"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-152a2b56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/components/website/bottomNav.vue
// module id = null
// module chunks = 